/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Bridge_Hosts_Per_ConnectionInputs */



/**
* | output |
* | --- |
* | "Host depends on the individual connection" |
*
* @param {Api_Bridge_Hosts_Per_ConnectionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const api_bridge_hosts_per_connection = /** @type {((inputs?: Api_Bridge_Hosts_Per_ConnectionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Bridge_Hosts_Per_ConnectionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Host hängt von der einzelnen Verbindung ab")
	return /** @type {LocalizedString} */ ("Host depends on the individual connection")
});